import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserbackService } from './shared/services/userback.service';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('adapei-frontend');
  
  private readonly userbackService = inject(UserbackService);
  private readonly authService = inject(AuthService);

  ngOnInit(): void {
    // Initialiser Userback avec l'utilisateur connecté
    this.initializeUserback();
  }

  /**
   * Initialise Userback et identifie l'utilisateur connecté
   */
  private initializeUserback(): void {
    this.authService.currentUser$.subscribe(user => {
      if (user) {
        // Utilisateur connecté - l'identifier dans Userback
        this.userbackService.identify({
          id: user.id.toString(),
          name: user.name,
          email: user.email,
          role: user.role
        });
      } else {
        // Utilisateur déconnecté
        this.userbackService.logout();
      }
    });
  }
}
